<template>
  <!-- 首页导航和轮播组件 -->
  <div class="navSwiper">
    <!-- 首页通知 -->
    <!-- 轮播组件 -->
    <div class="news">
      <div class="wrap">
        <!-- 左侧 noticeListshowImg 轮播图 -->
        <div class="showImg">
          <!-- 轮播图片 -->
          <img @mouseover="changeInterval(true)" @mouseleave="changeInterval(false)" v-for="(item, index) in imgArr"
            :key="item.id"
            :src="item.articleImg.startsWith('/profile') ? `http://www.shx93.gov.cn/prod-api${item.articleImg}` : `http://www.shx93.gov.cn/prod-api/profile/${item.articleImg}`"
            @click="toNewsDetail(item.id)" alt="暂无图片" v-show="index === currentIndex" />
          <!-- 左侧按钮 -->
          <div @click="clickIcon('up')" class="iconDiv icon-left">
            <i class="el-icon-arrow-left" style="color: white"></i>
          </div>
          <!-- 右侧按钮 -->
          <div @click="clickIcon('down')" class="iconDiv icon-right">
            <i class="el-icon-arrow-right" style="color: white"></i>
          </div>

          <!-- 背景文字的 -->
          <div class="banner-title">
            <p class="desc_title" v-for="(item, index) in imgArr" :key="item.id" v-show="index === currentIndex">
              {{ item.title }}</p>
          </div>
          <!-- 控制圆点 -->
          <div class="banner-circle">
            <ul>
              <li v-for="(item, index) in imgArr" @click="changeImg(index)" :key="item.id"
                :class="index === currentIndex ? 'active' : ''"></li>
            </ul>
          </div>
        </div>
        <!-- 第一条新闻 -->
        <div class="newsItem fl">
          <el-tabs class="menu-tabs" ref="navTabs">
            <el-tab-pane v-for="tab in secondNavList" :key="tab.id" :label="tab.navName">
            </el-tab-pane>
          </el-tabs>
          <ul class="news-list">
            <li v-for="mes in mesList" :key="mes.id" @click="$router.push(`/newsDetail?tm=${mes.id}`)">
              <i class="el-icon-caret-top"></i>
              {{ mes.title }}
            </li>
          </ul>
        </div>
        <!-- 主席信箱 -->
        <div class="mailBox fr" style="margin-left: 35px">
          <!-- 主委信箱 -->
          <a href="#" target="_blank">
            <div class="text" @click.prevent="toDetail">主委信箱</div>
          </a>

          <!-- 通知公告 -->
          <div class="navSwiper_right_Box">
            <div class="top">
              <div class="title">通知公告</div>
              <div class="more">
                <router-link to="/noticeList" class="more">+更多</router-link>
              </div>
            </div>
            <div class="content">
              <div class="item" v-for="item in noticeList" :key="item.id" @click="gotoNoticeDetail(item.id)"
                :title="item.title">
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="text1" @click="gotoOA">
            <div>协同办公平台</div>
          </div>
          <!-- <div class="img">
            <a>
              <img style="width: 204px" :src="'http://www.shx93.gov.cn/prod-api' + basicInfo.presidentImg" />
            </a>
            <div class="desc_titles">主席致辞</div>
          </div> -->
        </div>
      </div>
    </div>
    <!------------ 历届委员会 --------------->
    <!-- <div class="ztzl">
      <div class="title">
        <p>历届委员会</p>
        <span @click="ljwyhMore">更多></span>
      </div>
      <div class="content">
        <img src="../../assets/image/ljwyh.png" @click="ljwyhMore" alt="" style="width: 100%; margin-bottom: -10px" />
      </div>
    </div> -->
    <!--专题回顾 end-->
    <!-- 新闻列表开始 -->
    <!-- 放图片（轮播图）的专题专栏 -->
    <div class="ztzl">
      <div class="content">
        <img :src="`http://www.shx93.gov.cn/prod-api${ztzlBannerPic}`" @click="ljwyhMore" alt=""
          style="width: 100%; margin-bottom: -10px;height: 200px;" />
      </div>
    </div>
    <courseType></courseType>
  </div>
</template>

<script>
import courseType from "./courseType.vue";

export default {
  data() {
    return {
      basicInfo: "",
      noticeList: [],
      sliders: [],
      firstNews: [],
      // ---------------
      currentIndex: 0,
      timer: null, //定时轮询
      imgArr: [],
      secondNavList: [],
      currentMenuIndex: null,
      mesList: [],
      ztzlBannerPic: ''
    };
  },
  created() {
    this.getloginInfoAdd()
    this.getSliders();
    this.getNoticeList();
    this.getFirstNews();
    this.startInterval();
    this.getNavList();
  },
  mounted() {
    this.getBannerPic()
    this.getNoticeList();
  },
  methods: {
    async getloginInfoAdd() {
      let res = await this.$api.nav.loginInfoAdd({ requreUrl: '/api/business/ad/list/v2' })
      // console.log('访问量接口：',res);
    },
    gotoOA() {
      window.open('https://oa.shx93.gov.cn:8080')
    },
    async gotoNoticeDetail(_id) {
      this.$router.push(`/noticeDetail?tm=${_id}`)
    },
    // 获取专题专栏图片
    async getBannerPic() {
      let res = await this.$api.nav.getBannerPic(3);
      this.ztzlBannerPic = res.data.rows[0] && res.data.rows[0].mediaPath
    },
    changeTabTagir() {
      this.$nextTick(() => {
        this.$refs.navTabs.$refs.nav.$nextTick(() => {
          var target = document.getElementsByClassName("el-tabs__item");
          let that = this;
          for (let i = 0; i < target.length; i++) {
            target[i].addEventListener("mouseover", () => {
              that.$refs.navTabs.handleTabClick(1, String(i));
              that.getArticle(that.secondNavList[i].id);
            });
          }
        });
      });
    },
    async getNavList() {
      const { data, status } = await this.$api.nav.getNavList(1, '1139884748915605504');
      if (status !== 200) return;
      this.secondNavList = data.data;
      this.changeTabTagir();
      this.getArticle(this.secondNavList[0].id);
    },
    async getArticle(id) {
      const { data, status } = await this.$api.nav.getArticle(id, 1, 10, 1);
      if (status !== 200) return;
      this.mesList = data.rows.splice(0, 6)
    },
    ljwyhMore() {
      // this.$router.push(`/newsDetail?title=历届委员会`)
      this.$router.push(`/newsList?title=专题专栏`)

      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { title: "社委组成成员" },
      // });
    },
    toNewsDetail(_id) {
      this.$router.push(`/newsDetail?tm=${_id}`)
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { id: _id },
      // });
    },
    async gotoDetail(_id) {
      // console.log(id);
      this.$router.push(`/newsDetail?tm=${_id}`)
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { id: id },
      // });
    },
    // 获取第一条新闻
    async getFirstNews() {
      let res = await this.$api.nav.getFooterInfo();
      // console.log("第一条新闻结果", res.data);
      this.firstNews = res.data.article;
      this.basicInfo = res.data.siteBaseInfo;
    },
    toDetail() {
      this.$router.push(`/Email?email=${this.basicInfo.presidentEmail}`)
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { email: this.basicInfo.presidentEmail },
      // });
    },

    // 获取首页通知列表
    async getNoticeList() {
      let res = await this.$api.nav.getNoticeList();
      // 通知列表只保留前两条，点更多可以查看所有
      // this.noticeList = res.data.rows.splice(0, 2);
      this.noticeList = res.data.rows.splice(0, 3);
    },

    // 获取轮播图
    async getSliders() {
      let res = await this.$api.nav.getSliders();
      let arr = res.data.rows;
      // console.log('arr',arr);
      this.imgArr = arr.filter((current, index, arr) => {
        return current.articleImg
      })
      // this.imgArr = arr.sort((v) => v.isShowTop == 1 && v.articleImg);
      // console.log("轮播图", this.imgArr);
    },
    // ----------------
    //开启定时器
    startInterval() {
      // 事件里定时器应该先清除再设置，防止多次点击直接生成多个定时器
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.currentIndex++;
        if (this.currentIndex > this.imgArr.length - 1) {
          this.currentIndex = 0;
        }
      }, 2000);
    },
    // 点击左右箭头
    clickIcon(val) {
      if (val === "down") {
        this.currentIndex++;
        if (this.currentIndex === this.imgArr.length) {
          this.currentIndex = 0;
        }
      } else {
        if (this.currentIndex === 0) {
          this.currentIndex = this.imgArr.length;
        }
        this.currentIndex--;
      }
    },
    // 点击控制圆点
    changeImg(index) {
      this.currentIndex = index;
      this.startInterval()
    },
    //鼠标移入移出控制
    changeInterval(val) {
      if (val) {
        clearInterval(this.timer);
      } else {
        this.startInterval();
      }
    },
  },
  components: {
    courseType,
  },
};
</script>

<style lang="scss" scoped>
/* 公共样式 */

.wrap {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

body {
  background: #ffffff;
  overflow-x: hidden;
}

.navSwiper {
  width: 100%;
  height: 100%;

  .wrap {
    display: flex;
  }
}

/* 设置提交按钮 */
form {
  display: flex;
}

/*news*/
.news {
  position: relative;
  padding: 20px 0px;

  // --------------轮播图片-----------------
  .showImg {
    position: relative;
    width: 45%;
    height: 320px;
    overflow: hidden;
  }

  /* 轮播图片 */
  .showImg img {
    width: 100%;
    height: 100%;

    &:hover {
      cursor: pointer;
    }
  }

  /* 箭头图标 */
  .iconDiv {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    // border: 1px solid #666;
    // border-radius: 15px;
    // background-color: rgba(125, 125, 125, 0.2);
    line-height: 30px;
    text-align: center;
    font-size: 25px;
    cursor: pointer;
  }

  // .iconDiv:hover {
  //   background-color: white;
  // }

  .icon-left {
    left: 10px;
  }

  .icon-right {
    right: 10px;
  }

  /* 控制圆点 */
  .banner-circle {
    position: absolute;
    bottom: 8px;
    right: 0;

  }

  .banner-circle ul {
    margin-right: 20px;
    height: 20px;
    // width: 160px;
    display: flex;
    text-align: right;
  }

  .banner-circle ul li {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 5px;
    border-radius: 7px;
    // background: rgba(0, 0, 0, 0.3);
    border: 1px solid #fff;
    cursor: pointer;
  }

  .banner-title {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 40px;
    background: rgba(0, 0, 0, .4);
    // background-color: #000;
    padding-left: 18px;

    .desc_title {
      color: #fff !important;
      line-height: 40px;
      z-index: 200;
    }

    p {
      width: 65%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .active {
    background-color: rgb(255, 255, 255) !important;
  }
}

/* 清除li前面的圆点 */
li {
  list-style-type: none;
}

// -----------------第一条新闻------------------------
.newsItem {
  width: 34%;
  margin-left: 3%;

  .menu-tabs {
    ::v-deep {
      .el-tabs__item {
        font-size: 16px;
      }

      .el-tabs__item.is-active {
        font-size: 18px;
      }
    }
  }

  .news-list {
    // display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    >li {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      line-height: 46px;
      cursor: pointer;

      >i {
        transform: rotate(90deg)
      }
    }
  }

  // .newsItem ul li {
  //   padding: 8px 0;

  //   .newsItem ul li a {
  //     color: #323232;
  //     font-size: 16px;
  //     line-height: 24px;
  //     display: block;
  //     position: relative;
  //     padding-left: 20px;
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //   }

  //   .newsItem ul li a:before {
  //     content: "";
  //     width: 0;
  //     height: 0;
  //     border-top: 5px solid transparent;
  //     border-bottom: 5px solid transparent;
  //     border-left: 5px solid #323232;
  //     position: absolute;
  //     top: 50%;
  //     left: 0;
  //     transform: translateY(-50%);
  //     transition: 0.3s;
  //   }
  // }

  // .newsItem ul li a:before {
  //   content: "";
  //   width: 0;
  //   height: 0;
  //   border-top: 5px solid transparent;
  //   border-bottom: 5px solid transparent;
  //   border-left: 5px solid #323232;
  //   position: absolute;
  //   top: 50%;
  //   left: 0;
  //   transform: translateY(-50%);
  //   transition: 0.3s;
  // }

  // .newsItem ul li span {
  //   width: 4px;
  //   height: 8px;
  //   color: #333333;
  // }

  // .newsItem ul li:hover a {
  //   color: #ac2e33;
  // }

  // .newsItem ul li:hover a:before {
  //   border-left: 5px solid #ac2e33;
  //   transition: 0.3s;
  // }

  .button-check {
    background-color: rgb(28, 116, 205);
    /* Green */
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    font-weight: 900;
    margin-top: 36px;

    &:hover {
      cursor: pointer;
    }
  }
}

// ----------------------主席信箱----------------
.mailBox {
  width: 21%;

  .navSwiper_right_Box {
    .top {
      box-sizing: border-box;
      padding: 8px 10px 8px 15px;
      display: flex;
      color: rgb(28, 116, 205);
      background-color: white;
      border: 1px solid rgb(28, 116, 205);

      .title {
        font-size: 22px;
        text-align: left;
        flex: 2;
      }

      .more {
        line-height: 30px;
        font-size: 15px;
        color: rgb(28, 116, 205);
      }
    }

    .content {
      padding: 27px 10px 10px 15px;
      box-sizing: border-box;
      background-color: #f5f5f5;
      // border: 1px solid rgb(28, 116, 205);
      height: 160px;

      .item {
        position: relative;
        margin-bottom: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        // &:before {
        //   position: absolute;
        //   display: block;
        //   width: 10px;
        //   height: 10px;
        //   border-radius: 50%;
        //   background: #fa6861;
        //   content: '';
        // }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .text {
    background: rgb(28, 116, 205);
    font-size: 22px;
    color: #fff;
    height: 45px;
    line-height: 43px;
    text-align: center;
    position: relative;
    padding-left: 13%;
    margin-bottom: 7px;
    margin-top: 5px;
    letter-spacing: 4px;

    &:hover {
      cursor: pointer;
    }
  }

  .text1 {
    background: rgb(28, 116, 205);
    // border: 1px solid rgb(28, 116, 205);
    font-size: 22px;
    color: #fff;
    height: 45px;
    line-height: 43px;
    text-align: center;
    position: relative;
    // padding-left: 18%;
    margin-bottom: 7px;
    margin-top: 5px;
    letter-spacing: 4px;

    &:hover {
      cursor: pointer;
    }
  }

  .text:before {
    content: "";
    background: url("../../assets/image/icon_mail.png") no-repeat;
    position: absolute;
    top: 50%;
    left: 16%;
    transform: translateY(-50%);
    width: 32px;
    height: 24px;
  }

  .img {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;

    .img img {
      width: 100%;
    }

    .desc_titles {
      position: absolute;
      left: 0;
      bottom: 4px;
      width: 100%;
      height: 50px;
      background: rgba(28, 116, 205, .5);
      text-align: center;
      line-height: 50px;
      color: #fff;
      font-size: 20px;
      letter-spacing: 6px;
    }
  }
}

.index-newsTab {
  // border-bottom: 1px solid #d5d5d5;
  height: 70px;

  .headline {
    font-weight: 900;
    font-size: 18px;
    padding-bottom: 24px;
    border-bottom: 1px solid #d5d5d5;

  }

  .index-newsTab a {
    display: inline-block;
    line-height: 50px;
    transform-origin: all 0.4s;
    margin: 0 15px;
    text-align: center;
    font-size: 18px;
    color: #323232;
    position: relative;
  }

  .index-newsTab a:last-child {
    margin-right: 0;
  }

  .index-newsTab a:hover {
    transition: all 0.4s;
    color: #bc1b2d;
    font-size: 22px;
  }

  .index-newsTab a::after {
    content: "";
    display: inline-block;
    width: 0%;
    height: 1px;
    background: #bc1b2d;
    position: absolute;
    bottom: -1px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    transform: translateX(-50%);
    transition: all 0.4s;
  }

  .index-newsTab a:hover::after {
    transition: all 0.4s;
    width: 100%;
  }
}

// ------------------历届委员会-----------------
.ztzl {
  background-color: white;
  width: 1200px;
  margin: auto;
  // background-color: white;
  border-radius: 8px 8px 0px 0px;
  box-shadow: 0px 0px 5px 5px #f5f5f5;
  margin-bottom: 30px;

  .title {
    display: flex;
    justify-content: space-between;
    color: #2f2f2f;
    padding: 10px 15px 5px;

    // border-bottom: 2px solid #ccc;
    p {
      font-size: 23px;
      font-weight: bolder;
    }

    span {
      font-size: 18px;
      color: #2861a8;
    }
  }
}

@media screen and (max-width: 768px) {
  .ztzl {
    .content img {
      height: 90px !important;
    }
  }

  .content {
    img {
      height: 130px !important;
    }
  }

  .news .banner-title {
    padding: 0 10px !important;
    box-sizing: border-box;
    height: 30px;

    .desc_title {
      line-height: 30px;
    }

    p {
      width: 100%;
    }
  }

  .news .banner-circle {
    bottom: 29px;
    left: 43%;
  }

  .index-newsTab {
    .headline {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .newsItem {
    width: 100%;
    margin-left: 0;
    padding: 20px;
    box-sizing: border-box;
    margin-top: 0;

    .news-tabCont {
      margin-top: 10px;
    }

    .index-newsTab {
      height: auto;

      .headline {
        padding-bottom: 10px;
        font-weight: bold;
      }
    }

    .button-check {
      margin-top: 10px;
      padding: 6px 7px;
      font-size: 12px;
      margin-top: 16px;
      float: right;
    }
  }

  .Inform-news {
    display: none !important;
  }

  .wrap {
    display: flex;
    flex-direction: column;

    .showImg {
      width: 100%;
      height: 250px;
    }

    .newsItem {
      display: none;
    }

    .mailBox {
      display: none;
    }
  }

  .ztzl {
    // width: 41rem;
    width: 100%;
    margin: 0;

    .title {
      padding: 10px 15px;

      p {
        font-size: 16px;
      }

      span {
        font-size: 14px;
      }
    }
  }
}
</style>
